// extracted by mini-css-extract-plugin
module.exports = {"dynamicContent":"az_inc","title":"az_jnc","label":"az_knc"};